import './vueBeforeInit.js'
import '../js/longtouch'
import '../js/v-filter'

import $x from './$x'
import { initThemeColor } from './themeColorClient'
import '../router/permission'
import loadScripts from './utils/loadScripts';
import serverMap from '../../config/serverMap.js';
import kyEvent from './kyEvent';

export default function () {
    return $x.post('login/getUserInfo').then(res => {
        var info = res || {}
        $x.userInfo.setUserInfo(info)
        $x.userInfo.save()

        if (info.wartermark) loadScripts($x.serverMap.domain + 'api/home/getWatermark')

        //多语言js，加载完毕才能显示
        var proMsgs = new Promise(resolve => {
            loadScripts(serverMap.domain + 'Scripts/Msg.aspx?module=mobile&nocommon=1&lgid=' + info.lgid + '&_cv=' + info.cacheVer, resolve)
        })
        var promises = [proMsgs, initThemeColor()];
        //kyModule定制
        if (info.kyModule) promises.push(kyCustomize(info));
        $x.post('/manage/isadmin', {}).then(res0 => {
            $x.userInfo.isadmin = res0.isadmin;
        })
        return Promise.all(promises)
    })
}

function kyCustomize(info) {
    document.body.insertAdjacentHTML('beforeend', '<link href="Custom/app-plus.css?_cv=' + info.cacheVer + '" type="text/css" rel="stylesheet">');
    return new Promise(resolve => {
        loadScripts(serverMap.domain + 'Custom/app-plus.js?_cv=' + info.cacheVer, function () {
            kyEvent.init()
            resolve()
        })
    })
}
